export default __webpack_public_path__ + "static/media/chrome_mobile.0b05da7a.svg";